import React, {Component} from 'react';
import {observer} from 'mobx-react';
import SvgIcon from '@material-ui/core/SvgIcon';
import {withHover} from '../../../compose/withHover';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {primary, typoDark, white} from '../../../themes/colors';
import {FormattedMessage} from 'react-intl';
import {Tooltip} from '@material-ui/core';

@withHover
@observer
class MarkupToolButton extends Component {

    render() {
        const {onClick, buttonClass, icon, iconViewBox, isHovering, onMouseLeave, onMouseOver, toolTipText, isActive, color} = this.props;

        const buttonClasses = classNames({
            [buttonClass] : buttonClass,
            'active' : isActive,
            'markup-btn': true,
        })

        const buttonStyles = {
            "--tool-color" : (isActive || isHovering) ? white : color,
            "--tool-color-dark" : (isActive || isHovering) ? white : typoDark,
            "--shape-color" : isActive ? primary : typoDark
        }

        const title = toolTipText ? <FormattedMessage id={toolTipText}/> : ''

        return (
            <Tooltip title={title} placement='top' enterDelay={300} classes={{tooltip: 'icon-tooltip', popper: 'icon-tooltip-wrapper'}}>
                <button className={buttonClasses} style={buttonStyles} onMouseOver={onMouseOver} onMouseLeave={onMouseLeave} onClick={onClick} >
                    <SvgIcon viewBox={iconViewBox || '0 0 24 24'}>{icon}</SvgIcon>
                </button>
            </Tooltip>
        );
    }
};

MarkupToolButton.propTypes = {
    icon: PropTypes.object.isRequired,
    buttonClass: PropTypes.string,
    toolTipText: PropTypes.string,
    onClick: PropTypes.func.isRequired
};

export default MarkupToolButton;
